import { useRef } from 'react';
import { z } from 'zod';
import ModalWrapper from '../ModalWrapper';
import { FormWrapper, CommonFooter } from '../FormComponent';
import styles from '../../styles/assetsManagement/filesManager.module.scss';

const folderFormSchema = z.object({
  folderName: z
    .string()
    .trim()
    .min(1, 'Folder name is required')
    .max(100, 'Folder name must be 100 characters or less'),
  folderDescription: z
    .string()
    .max(500, 'Description must be 500 characters or less')
    .optional()
    .or(z.literal('')),
});

const FolderFormModal = ({ type = 'create', initialData = {}, onSubmit, onClose, loading }) => {
  const formRef = useRef();
  const isCreate = type === 'create';

  const buttons = [
    { label: 'Cancel', variant: 'outline', className: 'primary', onClick: onClose, disabled: loading },
    {
      label: loading ? (isCreate ? 'Creating…' : 'Saving…') : (isCreate ? 'Create' : 'Save'),
      variant: 'primary',
      className: 'white bg-blue600',
      onClick: () => formRef.current?.submit(),
      disabled: loading,
    },
  ];

  return (
    <ModalWrapper
      isOpen
      onClose={onClose}
      title={isCreate ? 'New Folder' : 'Rename Folder'}
      size="small"
      footer={<CommonFooter buttons={buttons} />}
    >
      <div className={styles.folderFormBody}>
        <FormWrapper
          ref={formRef}
          schema={folderFormSchema}
          fields={[
            { name: 'folderName', type: 'text', label: 'Folder Name', required: true, autoFocus: true },
            { name: 'folderDescription', type: 'text', label: 'Description (optional)', multiline: true, rows: 2 },
          ]}
          onSubmit={(values) =>
            onSubmit({
              folderName: values.folderName,
              folderDescription: values.folderDescription || undefined,
              parentFolderId: initialData.parentFolderId ?? null,
            })
          }
          defaultValues={{
            folderName: initialData.folderName || '',
            folderDescription: initialData.folderDescription || '',
          }}
        />
      </div>
    </ModalWrapper>
  );
};

export default FolderFormModal;
